import { render, staticRenderFns } from "./DecorationSubTitle.vue?vue&type=template&id=40179099&scoped=true&"
import script from "./DecorationSubTitle.vue?vue&type=script&lang=js&"
export * from "./DecorationSubTitle.vue?vue&type=script&lang=js&"
import style0 from "./DecorationSubTitle.vue?vue&type=style&index=0&id=40179099&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40179099",
  null
  
)

export default component.exports